import { Link } from 'react-router-dom'
import parkinsonsInsightsLogo from '@presentation/assets/icons/parkinsons-insights-logo-icon.svg'

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/news', label: 'News' },
  { to: '/webinars', label: 'Webinars' },
  { to: '/hacks', label: "Michel's PD Hacks" },
  { to: '/prof-bas-bloem-weekly', label: 'Prof Bas Bloem' },
  { to: '/dr-michael-okun-my-take', label: 'Prof Michael Okun' },
  { to: '/about', label: 'About Us' },
]

const LEGAL_LINKS = [
  { to: '/legal/medical-disclaimer', label: 'Medical Disclaimer' },
  { to: '/legal/privacy-policy', label: 'Privacy Policy' },
  { to: '/legal/terms-of-service', label: 'Terms of Service' },
  { to: '/legal/cookie-policy', label: 'Cookie Policy' },
  { to: '/legal/faqs', label: 'FAQs' },
]

const CONTACT_EMAILS = [
  'beatrice@pdbuddy.app',
  'michel@nosilverbullet4pd.com',
]
const BRAND_MOTTO =
  "Stop being a passenger, drive your own care with a holistic approach to Parkinson's."

export default function Footer() {
  return (
    <footer className="text-text-on-dark">
      <div className="bg-linear-to-r from-green to-blue">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-[3fr_1fr_1fr_1fr]">
            <div>
              <Link to="/" className="inline-block no-underline">
                <img
                  src={parkinsonsInsightsLogo}
                  alt="Parkinson's Insights"
                  className="h-24 w-auto brightness-0 invert sm:h-28"
                />
              </Link>
              <p
                className="mt-3 max-w-xs text-center text-sm leading-relaxed text-white/80 italic font-semibold"
              >
                {BRAND_MOTTO}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wide text-white">
                Quick Links
              </h4>
              <ul className="mt-3 space-y-2">
                {QUICK_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-white/80 no-underline transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wide text-white">
                Legal
              </h4>
              <ul className="mt-3 space-y-2">
                {LEGAL_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      onClick={
                        link.to === '/legal/faqs'
                          ? () => {
                              window.scrollTo({ top: 0, left: 0 })
                            }
                          : undefined
                      }
                      className="text-sm text-white/80 no-underline transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wide text-white">
                Contact Us
              </h4>
              <ul className="mt-3 space-y-2">
                {CONTACT_EMAILS.map((email) => (
                  <li key={email}>
                    <a
                      href={`mailto:${email}`}
                      className="text-sm text-white/80 no-underline transition-colors hover:text-white"
                    >
                      {email}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-8 border-t border-white/20 pt-8 text-center">
            <p className="text-sm text-text-on-dark/50">
              &copy; {new Date().getFullYear()} Parkinson's Insights. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
